import { FC, useState } from 'react';
import { Delete } from 'jbc-front/components/icons';
import Button from 'jbc-front/components/Button';
import { Modal } from 'jbc-front/components/presenters/ui/Modal';
import { useMutation } from '@/hooks/graphql/useMutation';
import { useNotify } from '@/hooks/useNotify';
import { User } from '../../query';
import styles from './DeleteUser.scss';
import { CHANGE_ROLE_FOR_DELETE_USER, ChangeRoleForDeleteUserQueryVariables } from './query';

interface DeleteUserProps {
  user: User;
  refetch: () => void;
  className?: string;
}

export const DeleteUser: FC<DeleteUserProps> = ({ user, refetch, className }) => {
  const notify = useNotify();

  const [isOpen, setIsOpen] = useState(false);
  const handleCloseModal = () => setIsOpen(false);

  const [changeRoleForDeleteUser, { loading: deleting }] = useMutation<unknown, ChangeRoleForDeleteUserQueryVariables>(
    CHANGE_ROLE_FOR_DELETE_USER
  );

  const name = (() => {
    if (user.employee) {
      return `${user.employee.lastName} ${user.employee.firstName} (${user.email})`;
    }
    if (user.name) {
      return `${user.name} (${user.email})`;
    }
    return user.email;
  })();

  const handleSubmit = async () => {
    await changeRoleForDeleteUser({
      variables: {
        input: {
          userRoleChanges: [
            {
              id: user.id,
              roleCodes: user.roles.map(role => role.roleCode),
              delete: true
            }
          ]
        }
      }
    });

    notify('削除しました', 'success');
    setIsOpen(false);
    refetch();
  };

  return (
    <>
      <span className={className} onClick={() => setIsOpen(true)}>
        <Delete size={20} />
      </span>
      <Modal isOpen={isOpen} onClose={handleCloseModal}>
        <Modal.Header onClose={handleCloseModal}>削除確認</Modal.Header>
        <Modal.Body>
          <b>{name}</b> の権限を削除します。
          <br />
          削除された管理者は健康管理にログインできなくなります。よろしいですか？
        </Modal.Body>
        <Modal.Footer className={styles.modalFooter}>
          <Button className={styles.footerButton} onClick={handleCloseModal}>
            いいえ
          </Button>
          <Button className={styles.footerButton} primary onClick={handleSubmit} disabled={deleting}>
            はい
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
